import { useEffect, useRef, useState } from 'react';

/** Carrega uma lista de apoio (opções de filtro). `fetcher()` retorna a resposta do axios. */
export default function useLookup(fetcher) {
    const [rows, setRows] = useState([]);
    const fetcherRef = useRef(fetcher);
    fetcherRef.current = fetcher;

    useEffect(() => {
        let cancelled = false;
        fetcherRef.current()
            .then((response) => {
                const data = response.data?.data || response.data;
                if (!cancelled) setRows(Array.isArray(data) ? data : []);
            })
            .catch((e) => console.error('Error loading lookup:', e));
        return () => {
            cancelled = true;
        };
    }, []);

    return rows;
}
